// src/components/shared/boot/uploadHelpers.js

/**
 * Deduplica uma lista de File/Blob.
 * Assinatura escolhida: name + size + lastModified (File).
 * - Evita envio duplicado no FormData (problema comum de state acumulando).
 */
export function dedupeFiles(list) {
    const seen = new Set();
    const out = [];

    for (const f of list || []) {
        // aceita File (e ignora objetos/undefined)
        if (!(f instanceof File)) continue;

        const sig = `${f.name}|${f.size}|${f.lastModified}`;
        if (seen.has(sig)) continue;

        seen.add(sig);
        out.push(f);
    }

    return out;
}

/**
 * Converte uma lista de "assets" { file: File } em File[]
 */
export function assetsToFiles(assets) {
    return (assets || []).map((a) => a?.file).filter((f) => f instanceof File);
}

/**
 * Detecta PDF por mimetype OU extensão (segurança).
 */
export function isPdfFile(file) {
    if (!(file instanceof File)) return false;
    const name = String(file.name || '').toLowerCase();
    const type = String(file.type || '').toLowerCase();
    return type === 'application/pdf' || name.endsWith('.pdf');
}
